// ======================================================================
// File Name       : DistributionReportContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================
import React from 'react';
import { connect } from 'react-redux';
import UnsubmittedReportSearch from '../../../components/report/unsubmitted/UnsubmittedReportSearch';
import UnsubmittedReportList from '../../../components/report/unsubmitted/UnsubmittedReportList';
import * as unsubmittedReportAction from '../../../actions/report/UnsubmittedReportAction';
import Header from '../../../components/Header';
import MessageSearch from '../../../components/MessageSearch';
import { isSuperUser } from '../../../utils/index';
import { getUserGroupRelation } from '../../../actions/UserAction';

class UnsubmittedReportContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isAllowShowSearchMessage: false,
    };
    this.dismissMessage = this.dismissMessage.bind(this);
    this.updateShowSearchMessageFlag = this.updateShowSearchMessageFlag.bind(this);
  }

  componentWillMount() {
    // search to return default data list
    const { dispatch } = this.props;
    dispatch(unsubmittedReportAction.resetUnsubmittedReport());
    dispatch(unsubmittedReportAction.getGroupList());
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(unsubmittedReportAction.resetUnsubmittedReport());
  }

  dismissMessage() {
    this.setState({ isAllowShowSearchMessage: false });
  }

  updateShowSearchMessageFlag(isAllowShowSearchMessage) {
    this.setState({ isAllowShowSearchMessage });
  }

  /**
   * Render function of component
   */
  render() {
    const { unsubmittedReport } = this.props;
    const { unsubmittedReportList } = unsubmittedReport;
    const { unsubmittedReportListResult, recordNum } = unsubmittedReportList;
    let isShowList = false;
    if (recordNum && unsubmittedReportListResult && unsubmittedReportListResult.length) {
      isShowList = true;
    }
    return (
      <div>
        <MessageSearch
          recordNum={recordNum}
          resultList={unsubmittedReportListResult}
          isAllowShowSearchMessage={this.state.isAllowShowSearchMessage}
          dismissMessage={this.dismissMessage}
        />
        <UnsubmittedReportSearch
          updateShowSearchMessageFlag={this.updateShowSearchMessageFlag.bind(this)}
          isShowList={isShowList}
        />
        {isShowList &&
          <UnsubmittedReportList 
            recordNum={recordNum}
            resultList={unsubmittedReportListResult}
          />}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { unsubmittedReport } = state;
  const { authedUser } = state.authed;
  return {
    unsubmittedReport,
    authedUser,
  };
};

export default connect(mapStateToProps)(UnsubmittedReportContainer);
